<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="dark-header">
          <h4 class="title">Danh sách Admin</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <md-button class="md-success button-add" @click="showDialog = true"
              >Thêm Admin</md-button
            >
          </div>
          <div class="scroll-x">
            <table id="customer">
              <tr>
                <th>Tên Admin</th>
                <th>Email</th>
                <th>Số điện thoại</th>
                <th>Địa chỉ</th>
                <th>Quyền hạn</th>
                <th>Khóa</th>
                <th>Chỉnh sửa</th>
                <th>Xóa</th>
              </tr>
              <tr
                :key="index"
                v-for="(item, index) in listAdmin"
                v-bind:class="{ danger: item.data.isBanned }"
              >
                <td>{{ item.data.name }}</td>
                <td>{{ item.data.email }}</td>
                <td>{{ item.data.phone }}</td>
                <td>
                  {{
                    item.data.address.length > 20
                      ? item.data.address.substring(0, 20) + "..."
                      : item.data.address
                  }}
                  <md-tooltip v-show="item.data.address.length > 20">{{
                    item.data.address
                  }}</md-tooltip>
                </td>
                <td>
                  <md-field>
                    <md-select
                      v-model="item.data.permission"
                      multiple
                      @md-opened="editing = true"
                      @md-closed="editAdmin(item)"
                    >
                      <md-option value="bill-management">Đơn hàng</md-option>
                      <md-option value="manage-products">Sản phẩm</md-option>
                      <md-option value="user-management">Nhân viên</md-option>
                      <md-option value="customer-management">Đại lý</md-option>
                      <md-option value="warehouse-management"
                        >Nhập kho</md-option
                      >
                      <md-option value="news-managements">Tin tức</md-option>
                    </md-select>
                  </md-field>
                </td>
                <td @click="confirmBanAdmin(item)" class="clickable">
                  <div v-show="!item.data.isBanned" style="color: green">
                    <i class="fas fa-lock-open"></i>
                    <md-tooltip>Tài khoản đang hoạt động</md-tooltip>
                  </div>
                  <div v-show="item.data.isBanned" style="color: red">
                    <i class="fas fa-lock"></i>
                    <md-tooltip>Tài khoản bị khóa</md-tooltip>
                  </div>
                </td>
                <td @click="editInfoAdmin(item)" class="clickable">
                  <div style="color: green">
                    <i class="fas fa-cog"></i>
                    <md-tooltip>Chỉnh sửa thông tin</md-tooltip>
                  </div>
                </td>
                <td @click="confirmDeleteAdmin(item)" class="clickable">
                  <div style="color: red">
                    <i class="fas fa-user-times"></i>
                    <md-tooltip>Xóa tài khoản</md-tooltip>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Thêm Admin</md-dialog-title>
      <md-dialog-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 md-xsmall-size-100">
            <div class="md-layout">
              <div class="md-layout-item md-size-60 md-xsmall-size-100">
                <md-field>
                  <label>Tên nhân viên:</label>
                  <md-input v-model="newAdmin.name"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-40 md-xsmall-size-100">
                <md-field>
                  <label>Mã nhân viên:</label>
                  <md-input v-model="newAdmin.adminId"></md-input>
                </md-field>
              </div>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Email:</label>
                <md-input v-model="newAdmin.email" type="email"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Vai trò:</label>
                <md-select v-model="newAdmin.permission" multiple>
                  <md-option value="bill-management">Đơn hàng</md-option>
                  <md-option value="manage-products">Sản phẩm</md-option>
                  <md-option value="user-management">Nhân viên</md-option>
                  <md-option value="customer-management">Đại lý</md-option>
                  <md-option value="warehouse-management">Nhập kho</md-option>
                  <md-option value="news-managements">Tin tức</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="md-layout-item">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Địa chỉ:</label>
                <md-input v-model="newAdmin.address"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Số điện thoại:</label>
                <md-input v-model="newAdmin.phone"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Mật khẩu:</label>
                <md-input v-model="newAdmin.password" type="text"></md-input>
              </md-field>
            </div>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-danger" @click="showDialog = false"
          >Đóng</md-button
        >
        <md-button class="md-primary" @click="addAdmin">Lưu</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="editingInfo">
      <md-dialog-title>Chỉnh sửa thông tin Admin</md-dialog-title>
      <md-dialog-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 md-xsmall-size-100">
            <div class="md-layout">
              <div class="md-layout-item md-size-60 md-xsmall-size-100">
                <md-field>
                  <label>Tên nhân viên:</label>
                  <md-input v-model="edit.data.name" disabled></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-40 md-xsmall-size-100">
                <md-field>
                  <label>Mã nhân viên:</label>
                  <md-input v-model="edit.data.adminId" disabled></md-input>
                </md-field>
              </div>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Email:</label>
                <md-input
                  v-model="edit.data.email"
                  type="email"
                  disabled
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Vai trò:</label>
                <md-select v-model="edit.data.permission" multiple>
                  <md-option value="bill-management">Đơn hàng</md-option>
                  <md-option value="manage-products">Sản phẩm</md-option>
                  <md-option value="user-management">Nhân viên</md-option>
                  <md-option value="customer-management">Đại lý</md-option>
                  <md-option value="warehouse-management">Nhập kho</md-option>
                  <md-option value="news-managements">Tin tức</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="md-layout-item">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Địa chỉ:</label>
                <md-input v-model="edit.data.address"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Số điện thoại:</label>
                <md-input v-model="edit.data.phone"></md-input>
              </md-field>
            </div>
          </div>
        </div>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(resetPassword)">
            <md-button class="md-success md-mini" type="submit"
              >Đổi mật khẩu</md-button
            >
            <md-field>
              <label>Mật khẩu mới:</label>
              <md-input required v-model="newPassword" type="text"></md-input>
            </md-field>
          </form>
        </ValidationObserver>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-danger" @click="editingInfo = false"
          >Đóng</md-button
        >
        <md-button
          class="md-primary"
          @click="
            editingInfo = false;
            editAdmin(edit);
          "
          >Lưu</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import { ProductCard } from "@/components";
import firebase from "@/services/firebase-init.js";
import Swal from "sweetalert2";
export default {
  created() {
    this.db = firebase.firestore();
    this.functions = firebase.functions();
    this.getData();
  },
  data() {
    return {
      newPassword: "",
      functions: null,
      showDialog: false,
      db: {},
      userSelected: {},
      listAdmin: [],
      selected: [],
      editing: false,
      editingInfo: false,
      newAdmin: {
        permission: [],
        name: "",
        email: "",
        address: "",
        phone: "",
        adminId: "",
        password: "",
      },
      edit: {
        id: "",
        data: {
          permission: [],
          name: "",
          email: "",
          address: "",
          phone: "",
          adminId: "",
        },
      },
    };
  },
  methods: {
    getData() {
      this.listAdmin = [];
      this.$store.dispatch("FLAG_LOADING", true);
      let bits = localStorage.getItem("bits");
      let query = this.db
        .collection(process.env.VUE_APP_ADMIN + bits)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((item) => {
            var tmp = Object.assign({}, item.data());
            if (tmp.isBanned === undefined) {
              this.$set(tmp, "isBanned", false);
            }
            this.listAdmin.push({
              id: item.id,
              data: tmp,
            });
          });
          this.$store.dispatch("FLAG_LOADING", false);
        });
    },
    addNewAdmin() {
      let bits = localStorage.getItem("bits");
      let addNewAdmin = this.functions.httpsCallable(
        process.env.VUE_APP_ADD_ADMIN_FUNC + bits
      );
      addNewAdmin({
        name: this.newAdmin.name,
        phone: this.newAdmin.phone,
        address: this.newAdmin.address,
        adminId: this.newAdmin.adminId,
        email: this.newAdmin.email.toLowerCase(),
        permission: this.newAdmin.permission,
        password: this.newAdmin.password,
      })
        .then((result) => {
          // console.log(result.data);
          if (result.data.success == false) {
            this.$store.dispatch("FLAG_LOADING", false);
            this.$messageError(result.data.message);
          } else {
            this.getData();
            this.$data.showDialog = false;
            this.$store.dispatch("FLAG_LOADING", false);
            this.$messageSuccess(result.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("FLAG_LOADING", false);
          this.$messageError(error.message);
        });
    },
    checkEmployeeName() {
      var bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_ADMIN + bits)
        .where("name", "==", this.newAdmin.name)
        .get()
        .then((querySnapshot) => {
          var check = true;
          querySnapshot.forEach((item) => {
            if (item) {
              check = false;
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageError("Tên tài khoản đã tồn tại");
            }
          });
          if (check) this.addNewAdmin();
        });
    },
    checkEmployeeCode() {
      var bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_ADMIN + bits)
        .where("adminId", "==", this.newAdmin.adminId)
        .get()
        .then((querySnapshot) => {
          var check = true;
          querySnapshot.forEach((item) => {
            if (item) {
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageError("Mã tài khoản đã tồn tại");
              check = false;
            }
          });
          if (check) this.checkEmployeeName();
        });
    },
    checkEmail() {
      this.newAdmin.email = this.newAdmin.email.toLowerCase();
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_ADMIN + bits)
        .where("email", "==", this.newAdmin.email.toLowerCase())
        .get()
        .then((doc) => {
          var check = true;
          doc.forEach((item) => {
            if (item) {
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageError("Email đã tồn tại");
              check = false;
            }
          });
          if (check) this.checkEmployeeCode();
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          console.log(error);
        });
    },
    addAdmin() {
      this.$store.dispatch("FLAG_LOADING", true);
      this.checkEmail();
    },
    editAdmin(item) {
      if (this.editing) {
        this.$store.dispatch("FLAG_LOADING", true);
        let bits = localStorage.getItem("bits");
        this.db
          .collection(process.env.VUE_APP_ADMIN + bits)
          .doc(item.id)
          .update(item.data)
          .then(() => {
            this.$store.dispatch("FLAG_LOADING", false);
          })
          .catch((error) => {
            this.$store.dispatch("FLAG_LOADING", false);
            console.log(error);
          });
        this.editing = false;
      }
    },
    editInfoAdmin(item) {
      this.edit = item;
      this.editing = true;
      this.editingInfo = true;
    },
    confirmBanAdmin(item) {
      Swal.fire({
        title: !item.data.isBanned
          ? "Khóa tài khoản: " + item.data.name
          : "Mở khóa tài khoản: " + item.data.name,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("FLAG_LOADING", true);
          !item.data.isBanned ? this.banAdmin(item) : this.enableAdmin(item);
        }
      });
    },
    banAdmin(item) {
      let banThisAdmin = this.functions.httpsCallable(
        process.env.VUE_APP_DISABLE_USER_FUNC
      );
      banThisAdmin({
        email: item.data.email,
      })
        .then((result) => {
          if (result.success === false) {
            this.$messageError("Có lỗi, Thử lại!");
            this.$store.dispatch("FLAG_LOADING", false);
          } else {
            this.updateBandAdmin(item);
            this.$messageSuccess("Đã khóa tài khoản");
          }
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          console.log(error);
          this.$messageError("Có lỗi, Thử lại!");
        });
    },
    enableAdmin(item) {
      let enableThisAdmin = this.functions.httpsCallable(
        process.env.VUE_APP_ENABLE_USER_FUNC
      );
      enableThisAdmin({
        email: item.data.email,
      })
        .then((result) => {
          if (result.success === false) {
            this.$store.dispatch("FLAG_LOADING", false);
            this.$messageError("Có lỗi, Thử lại!");
          } else {
            this.updateEnableAdmin(item);
            this.$messageSuccess("Đã mở khóa tài khoản");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$messageError("Có lỗi, Thử lại!");
        });
    },
    updateBandAdmin(item) {
      item.data.isBanned = true;
      this.updateAdmin(item);
    },
    updateEnableAdmin(item) {
      item.data.isBanned = false;
      this.updateAdmin(item);
    },
    updateAdmin(item) {
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_ADMIN + bits)
        .doc(item.id)
        .update(item.data)
        .then(() => {
          this.$store.dispatch("FLAG_LOADING", false);
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          console.log(error);
        });
    },
    confirmDeleteAdmin(item) {
      Swal.fire({
        title: "Xóa tài khoản: " + item.data.name,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("FLAG_LOADING", true);
          let bits = localStorage.getItem("bits");
          let deleteFunc = this.functions.httpsCallable(
            process.env.VUE_APP_DELETE_ADMIN_FUNC + bits
          );
          deleteFunc({
            email: item.data.email,
          })
            .then((result) => {
              this.$store.dispatch("FLAG_LOADING", false);
              if (result.success === false) {
                this.$messageError("Có lỗi, Thử lại!");
              } else {
                this.listAdmin = [];
                this.getData();
                this.$messageSuccess("Đã xóa tài khoản");
              }
            })
            .catch((error) => {
              console.log(error);
              this.$messageError("Có lỗi, Thử lại!");
            });
        }
      });
    },
    resetPassword(edit) {
      Swal.fire({
        title: "Đổi mật khẩu",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("FLAG_LOADING", true);
          let addNewUser = this.functions.httpsCallable(
            process.env.VUE_APP_RESET_PASSWORD_FUNC
          );
          addNewUser({
            email: this.edit.data.email,
            newPassword: this.newPassword,
          })
            .then((result) => {
              if (result.success === false) {
                this.$store.dispatch("FLAG_LOADING", false);
                this.$messageError("Có lỗi, Thử lại!");
              } else {
                this.$store.dispatch("FLAG_LOADING", false);
                this.$messageSuccess("Đổi mật khẩu thành công");
              }
            })
            .catch((error) => {
              this.$store.dispatch("FLAG_LOADING", false);
              this.$messageError(error.message);
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.add-user {
  font-size: 15px !important;
  background-color: rgba(0, 128, 0, 0.39) !important;
  padding: 3px 0 3px 0 !important;
}
.button-add {
  float: right;
}

.table-border {
  border: solid rgba(0, 0, 0, 0.178) 1px;
  border-radius: 10px;
}
.pagination {
  color: rgba(0, 0, 0, 0.301);
  font-size: 13px;
}
#customer {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border-radius: 10px;
  overflow-x: scroll;
}

#customer td,
#customer th {
  padding: 8px 10px 8px 10px;
  border: 1px solid #ddd;
  max-width: 20vw;
}

#customer tr:hover {
  background-color: #ddd;
}

#customer th {
  text-align: left;
  background-color: rgba(0, 165, 14, 0.356);
  color: rgb(0, 0, 0);
  font-style: normal;
  font-weight: normal;
}
.nummeric {
  text-align: right !important;
}
.danger {
  background: rgba(222, 184, 135, 0.397);
}
</style>
